var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ToggleMap'),_c('div',{ref:"map",attrs:{"id":"map"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }